import * as constant from "../constants/Constant";
import axios from "axios";

const upload = (file, onUploadProgress) => {
  let formData = new FormData();
  let token = localStorage.getItem("token");
  let supplier = localStorage.getItem("supplier");
  let parsedUser = JSON.parse(supplier);
  formData.append("file", file);
  formData.append("supplier_id", parsedUser.id);
  
  return axios.post(constant.baseUrl+"api/uploadProductFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token
    },
    onUploadProgress,
  });

};

const addSupplier = (data, onUploadProgress) => {
  let token = localStorage.getItem("token");
  
  return axios.post(constant.baseUrl+"api/admin/supplier/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token
    },
    onUploadProgress,
  });

};
const updateSupplierCredentials = (data, onUploadProgress) => {
  let token = localStorage.getItem("token");
  
  return axios.post(constant.baseUrl+"api/admin/supplier/update/credential", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token
    },
    onUploadProgress,
  });
};

const addUsers = (data) => {
  let token = localStorage.getItem("token");
  
  return axios.post(constant.baseUrl+"api/admin/user/create", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token
    },
  });

};

const uploadImage = (file, onUploadProgress) => {
  let formData = new FormData();
  let token = localStorage.getItem("token");
  let supplier = localStorage.getItem("supplier");
  let parsedUser = JSON.parse(supplier);
  var filesData = [];
  var i = 0;
  for (const iterator of file) {
    formData.append("file_"+i, iterator);
    i++;
  }
  
  formData.append("supplier_id", parsedUser.id);
  
  return axios.post(constant.baseUrl+"api/uploadBulkImages", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token
    },
    onUploadProgress,
  });

};
// const onUploadProgress = (progressEvent) => {
//   const { loaded, total } = progressEvent;
//   let percent = Math.floor((loaded * 100) / total);
//   if (percent < 100) {
//     console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
//   }
// };
//video upload
const uploadVideo = (formData,onUploadProgress) => {
  return axios.post(constant.baseUrl + "api/homePageVideo/uploadVideo", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("token")
    },
    onUploadProgress,
  });
}

const uploadImageFromDashboard = (formData) => {
  return axios.post(constant.baseUrl+"api/product/uploadImage", formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("token")
      }
  });
}
const uploadSliderFromDashboard = (formData) => {
  return axios.post(constant.baseUrl+"api/product/uploadSliderImage", formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("token")
      }
  });
}
const removeSliderFromDashboard = (formData) => {
  return axios.post(constant.baseUrl+"api/product/removeSliderImage", formData,{
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token")
      }
  });
}

const bulkUploads = (formData) => {
  return axios.post(constant.baseUrl+"api/admin/product/file/upload", formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("token")
      }
  });
}


const bulkUploadImage = (formData,onUploadProgress) => {
  return axios.post(constant.baseUrl+"api/admin/product/image/upload", formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("token")
      },
      onUploadProgress
  });
}

const activateMaintenanceMode = (formData) => {
  return axios.post(constant.baseUrl+"api/admin/maintenance", formData,{
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("token")
      }
  });
}



export default {
  upload,
  uploadImage,
  uploadVideo,
  uploadImageFromDashboard,
  bulkUploads,
  bulkUploadImage,
  uploadSliderFromDashboard,
  removeSliderFromDashboard,
  addSupplier,
  updateSupplierCredentials,
  activateMaintenanceMode,
  addUsers
};